import axios from 'axios';

const censusTracts = require('./census_tracts.json');
const lmiTracts = require('./lmi_tracts.json');
const mhLmiTracts = require('./mh_lmi_tracts.json');

const interestRates = require('./interest_rates.json');

const baseAPI = 'https://newsapidev.marketproof.com/query/';

const countyCodes = {
    1: 61,
    2: 5,
    3: 47,
    4: 81,
    5: 85,
};
const boroCodes = {
    61: 1,
    5: 2,
    47: 3,
    81: 4,
    85: 5,
};

export const _trimChar = (string, charToRemove) => {
    while(string.charAt(0) == charToRemove) {
        string = string.substring(1);
    }

    while(string.charAt(string.length - 1) == charToRemove) {
        string = string.substring(0, string.length - 1);
    }

    return string;
};

export const _getTract = (boroughCode, cTract) => {	
	if(!cTract || !boroughCode) return false;
	for (let i = 0; i < censusTracts.length; i++) {
		const tract = censusTracts[i];
		if(tract.c_code == countyCodes[boroughCode] 
			&& (tract.t_code == cTract || _trimChar(tract.t_code.toString(), '0') == _trimChar(cTract.toString()))
		) {
			return tract;
		}
	}
	return false;	
};

export const _getRate = (date) => {	
	if(!date) return false;
	for (let i = 0; i < interestRates.length; i++) {
		const period = interestRates[i];
		if(period.month.substring(0, 7) == date.substring(0, 7)) {
			return period.rate;
		}
	}
	return false;	
};

export const _getLMITract = (type = 'lmi') => {	
	let lmiQuery = '';
	console.log(type);
	const tracts = type === 'lmi-high' ? mhLmiTracts : lmiTracts;
	
	for (let i = 0; i < tracts.length; i++) {
		const tract = tracts[i];
		if(!(type === 'lmi-high' && [4, 5].indexOf(tract.b_code) >= 0)) {
			lmiQuery += '(borough_code:' + tract.b_code + ' AND census_tract:"' + tract.t_code + '") OR ';
		}
	}
	return '(' + lmiQuery.slice(0, lmiQuery.length - 4) + ')';	
};

export const _getLMITractData = () => {	
	const MHLmi = [];
	for (let i = 0; i < censusTracts.length; i++) {
		const tract = censusTracts[i];
		if([61, 5, 47, 81, 85].indexOf(tract.c_code) >= 0
			&& ['low', 'moderate'].indexOf(tract.income.toLowerCase()) >= 0
		) {
			MHLmi.push({ "c_code":tract.c_code, "b_code":boroCodes[tract.c_code], "t_code":tract.t_code });
		}
	}
	console.log(JSON.stringify(MHLmi));
};


export const _getLMIHighTractData = () => {	
	const MHLmi = [];
	for (let i = 0; i < censusTracts.length; i++) {
		const tract = censusTracts[i];
		if([61, 5, 47, 81, 85].indexOf(tract.c_code) >= 0
			&& ['middle', 'upper'].indexOf(tract.income.toLowerCase()) >= 0
		) {
			MHLmi.push({ "c_code":tract.c_code, "b_code":boroCodes[tract.c_code], "t_code":tract.t_code });
		}
	}
	console.log(JSON.stringify(MHLmi));
};

export const _axiosCall = async data => {
  console.log('axios call ', data);
  const response = await axios({
    method: data.method,
    url: data.url,
    data: data.query,
    params: data.params,
    headers: data.headers
  })
    .then(res => {
      console.log('bl axios res back', data.url);
      return res.data;
    })
    .catch(error => {
      return false;
    });
  return response;
};

export const _getClosedSales = async (query, obj) => {
	const fields = 'display_full_street_address,address_2_normalized,borough,borough_code,neighborhood,recorded_datetime,'
	        + 'close_date_formatted,contract_date_formatted,sales_document_ids,census_tract,price,financed_amt,'
	        + 'percent_financed,lender,ownership_type,owner,document_ids';
	const transCallData = {
	    url: baseAPI + 'we3-transactions?cache=60',
	    method: 'post',
	    query: {
	      fq:
	        'status:(sold) AND source_namespace:WE3 AND transaction_source:(ACRIS-DOC OR ACRIS) AND -lender:mers*'
	        + ' AND -lender:mrs AND ownership_type:(condo* coop* *family*) AND census_tract:*',
	      wt: 'json',
	      fl: fields,
	      rows: 20,
	      sort: 'recorded_datetime desc',
	      q: query,
	    }
	};
    const getTransactions = await _axiosCall(transCallData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getTransactions);
    }
    return getTransactions;
};


export const _getClosedSalesStats = async (query, obj) => {
	const fields = 'display_full_street_address,address_2_normalized,borough,borough_code,neighborhood,recorded_datetime,'
	        + 'close_date_formatted,contract_date_formatted,sales_document_ids,census_tract,price,financed_amt,'
	        + 'percent_financed,lender,ownership_type,owner,document_ids';
	const transCallData = {
	    url: baseAPI + 'we3-transactions?cache=1440',
	    method: 'post',
	    query: {
			"q": "*:*",
			"fq": ["source_namespace:WE3 AND transaction_source:(ACRIS-DOC OR ACRIS) AND -(address_2:\"\" AND parcels_unit_codes:*) AND parcels_count:[* TO 2] AND -property_type:ib AND -property_type:ap AND -property_type:ot AND -property_type:cp AND -property_type:ps AND -property_type:sr AND -property_type:cr AND -property_type:mp AND -property_type:mc AND -property_type:\"apartment building\"",
				"-sales_document_ids:(2013112600115002 2016021701802001 2010052500518001 2011090200119001 2013112600234001 2017092801355001 2018020900207001 2014052302639001 2014070800474001 2014031801040001 2013110500441001 2010011901205001 2017121200413001 2016042500275002 2015120900959001 2010010700030001 2012070300615001 2016122901434001 2012043000044001 2018111301256001 2016030300084001 2010030301431001 2012071801462001 2013102200634001 2010070200278001 2011040600063001 2013010200435001 2011092701351001 2012102201321001 2010052700604001 2013010200462001 2017032400246001 2017113000662001 2011120900473001 2012062601118001 2014072300382001 2016021101445001 2018043000141001 2010030900095001 2012032900574001 2012080800058002 2014020600868001 2014041000838001 2016062002898001 2010112301112001 2011102500603001 2011121300323001 2013112200039001 2014082601257001 2015040101292001 2015040101308001 2015070600569002 2015100500700001 2019071100180001 2010060700837003 2011020400681001 2012112601317001 2016041300453001 2016090901171001 2018110800275001 2014121500479001 2016052500888001 2018040200107001 2018081400218004 2019052101264001 2011121600915001 2012082200515002 2012121001199001 2013051301452001 2013111401469001 2014061100893001 2015070901739001 2015102101025001 2017030101286001 2018080100852001 2018110101137001 2019041800732001 2011012400318001 2013080600969001 2014022800567001 2014040100851001 2014121500936001 2015073001075001 2016081200984002 2018111400473001 2019061300307001 2019062501104001 2019092300883001 2011042000076001 2012042600876001 2012091400466001 2012123101109002 2013052101028002 2013071001546001 2015031600683001 2015062200304002 2015122200841001 2016042700847001 2017072000851001 2017092600836001 2018080600614001 2018080600889001 2010072200539001 2011070800299001 2012091400600001 2012112601377001 2014011500986001 2014022400903001 2014040100851002 2014072201245001 2014112400048001 2015050600282001 2015062200304001 2015062900225001 2015121800340001 2018121700899001 2010011901231001 2010040500446001 2012022100181001 2012082201627001 2014041100599002 2014090300634001 2015062201057001 2015100101429001 2015122201556001 2016021601159001 2017022400677001 2017123000014003 2018011700806001 2019080601271001 2019092500960001 2010110800914001 2011071401346001 2011101000381001 2011111701367001 2012042700752001 2012042700767001 2012071801283001 2012080601233001 2012092800671001 2013031700104001 2013051300413001 2013052301199001 2013121300594001 2014021201166001 2014082601122001 2014120400686001 2015050500683001 2015092100078001 2015092100089001 2015122100717001 2016080900220001 2016081200578001 2016083000446001 2016090800755001 2016101800801001 2017012401067001 2018071700640001 2018083100601001 2018083100634001 2010080200500001 2010111100532001 2011032400660001 2011101900139003 2011120800971001 2011121301078001 2011121600424001 2012032100353001 2012041600549001 2012060601035001 2012092401157001 2012100200312001 2012102300912001 2012121200993001 2013021400310001 2013022800228003 2013032601418003 2013040101305001 2013041100395001 2013051000514001 2013071901552001 2013082801627001 2013102501413001 2014011300407001 2014020500475001 2014041600482001 2014101700183003 2015061100770001 2015081401015001 2016031400451001 2016040401015001 2016062201552001 2016110801156001 2016122701433001 2016122701742002 2016122800698001 2017042600941001 2017091800659001 2017101100597001 2017101700133001 2017103000874001 2017121100998001 2017121201094001 2018010200052002 2018011800647001 2018042600739001 2018092400589001 2019052100073001 2019092400362001 2010010600618001 2010012200679001 2010022501047001 2010032500214001 2010061100953001 2010061600834001 2010062101042001 2010062400218001 2010070701094001 2010071100004001 2010071200015001 2010082000301001 2010090300262003 2010090800327001 2010101500034003 2010110201044001 2010110400428001 2010111100254001 2010111900400001 2010112900272001 2010112900562001 2010113000554001 2010120800423001 2011012100664003 2011012501062001 2011032800486002 2011051900688002 2011080101092001 2011101800981001 2011111701369001 2011123000415001 2012020201036001 2012041100015001 2012042301181004 2012050401221001 2012052900265002 2012053000124001 2012061600057001 2012062701302002 2012062900466001 2012080200871001 2012080800058001 2012081500224004 2012083101067001 2012091201638001 2012100500936001 2012110800401001 2012110900928001 2012111401078001 2012112100573001 2012120501586001 2012120700334001 2012121600015001 2012122400526001 2012122600256003 2012122700677004 2012123101005001 2013010200356001 2013010200719001 2013010901003003 2013011601779001 2013011701846002 2013011800483001 2013020500683001 2013022701221001 2013030200160002 2013032101093001 2013041500685001 2013061101106001 2013061400302001 2013063000061001 2013070300420001 2013071600701001 2013072500274001 2013081500618001 2013090301300001 2013090500136003 2013100101320001 2013101700489001 2013102201006001 2013110500487001 2013111201003001 2013112200523001 2013120600469003 2013121200661001 2013123000310001 2014011400656001 2014020400754001 2014020700822001 2014021100090001 2014030501364001 2010012701261001)"],
			"wt": "json",
			"rows": 0,
			"json.facet": {
				"closed_sales_condos": {
					"type": "query",
					"q": "price:[100000 TO 50000000] AND status:sold AND ownership_type:condo",
					"facet": {
						"monthly_closed": {
							"range": {
								"field": "close_date_formatted",
								"start": "2005-01-01T01:00:01Z",
								"end": "2019-11-01T00:00:01Z",
								"gap": "+1MONTH",
								"facet": {
									"average_price": "avg(price)",
									"median_price": "percentile(price,50)",
									"sum_price": "sum(price)"
								}
							}
						}
					}
				},
				"closed_sales_coops": {
					"type": "query",
					"q": "price:[100000 TO 50000000] AND status:sold AND ownership_type:coop",
					"facet": {
						"monthly_closed": {
							"range": {
								"field": "close_date_formatted",
								"start": "2005-01-01T01:00:01Z",
								"end": "2019-11-01T00:00:01Z",
								"gap": "+1MONTH",
								"facet": {
									"average_price": "avg(price)",
									"median_price": "percentile(price,50)",
									"sum_price": "sum(price)"
								}
							}
						}
					}
				},
				"closed_sales_townhouses": {
					"type": "query",
					"q": "price:[100000 TO 50000000] AND status:sold AND ownership_type:(single-family OR multi-family) AND building_style:townhouse",
					"facet": {
						"monthly_closed": {
							"range": {
								"field": "close_date_formatted",
								"start": "2005-01-01T01:00:01Z",
								"end": "2019-11-01T00:00:01Z",
								"gap": "+1MONTH",
								"facet": {
									"average_price": "avg(price)",
									"median_price": "percentile(price,50)",
									"sum_price": "sum(price)"
								}
							}
						}
					}
				},
				"average_discount": {
					"type": "query",
					"q": "discount:[-30 TO 30] AND status:(sold OR \"in contract\") AND ownership_type:(condo OR coop OR condop OR single-family OR multi-family)",
					"facet": {
						"monthly_closed": {
							"range": {
								"field": "close_date_formatted",
								"start": "2006-01-01T01:00:01Z",
								"end": "2019-11-01T00:00:01Z",
								"gap": "+3MONTH",
								"facet": {
									"average_discount": "avg(discount)",
									"median_discount": "percentile(discount,50)"
								}
							}
						}
					}
				},
				"ppsf": {
					"type": "query",
					"q": "price_per_sqft:[100 TO 10000] AND status:(sold) AND ownership_type:(condo OR coop OR condop OR single-family OR multi-family) AND sq_ft:[100 TO 10000]",
					"facet": {
						"monthly_ppsf": {
							"range": {
								"field": "close_date_formatted",
								"start": "2006-01-01T01:00:01Z",
								"end": "2019-11-01T00:00:01Z",
								"gap": "+3MONTH",
								"facet": {
									"bedrooms": {
										"type": "terms",
										"field": "bedrooms",
										"facet": {
											"average_ppsf": "avg(price_per_sqft)",
											"median_ppsf": "percentile(price_per_sqft,50)"
										}
									},
									"ownership_type": {
										"type": "terms",
										"field": "ownership_type",
										"facet": {
											"average_ppsf": "avg(price_per_sqft)",
											"median_ppsf": "percentile(price_per_sqft,50)"
										}
									},
									"average_ppsf": "avg(price_per_sqft)",
									"median_ppsf": "percentile(price_per_sqft,50)",
									"median_price": "percentile(price,50)",
								}
							}
						}
					}
				},
				"closed_sales_borough": {
					"type": "query",
					"q": "price:[75000 TO 50000000] AND status:sold AND ownership_type:(condo OR coop OR condop OR single-family OR multi-family)",
					"facet": {
						"time_range": {
							"range": {
								"field": "close_date_formatted",
								"start": "2010-01-01T01:00:01Z",
								"end": "2020-01-01T00:00:01Z",
								"gap": "+3MONTH",
								"facet": {
									"borough": {
										"type": "terms",
										"field": "borough",
										"facet": {
											"average_price": "avg(price)",
											"median_price": "percentile(price,50)",
											"sum_price": "sum(price)"
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};
    const getTransactions = await _axiosCall(transCallData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getTransactions);
    }
    return getTransactions;
};

export const _getRecentClosed = async (query, obj) => {
	const fields = "building_name,full_street_address,primary_full_street_address,address_2_normalized,neighborhood,borough,city,zip,ownership_type,bedrooms,baths,sq_ft,price,listed_price,price_per_sqft,recorded_datetime,close_date_formatted,days_to_contract,days_to_sold,days_to_last_price_change,days_from_last_price_change_to_contract,contract_date_formatted,listed_date_formatted,financed_date_formatted,last_price_change_date_formatted,owner,lender,borrower,agents,agent_emails,broker,discount,financed_amt,percent_finance,listing_source,source_namespace,property_category,listing_source_name,building,listing_key,listing_contract";
	const transCallData = {
	    url: baseAPI + 'we3-transactions?cache=1440',
	    method: 'post',
	    query: {
			"q": "*:*",
			"fl": fields,
			"fq": ["-property_type:ap",
		        "-property_type:cc",
		        "-property_type:cr",
		        "-property_type:d4",
		        "-property_type:d5",
		        "-property_type:d6",
		        "-property_type:f4",
		        "-property_type:f5",
		        "-property_type:fs",
		        "-property_type:ps",
		        "-property_type:sr",
		        "ownership_type:(*condo* *coop* *family*)",
		        "parcels_count:[* TO 2]",
		        "price:[995000 TO 999999]",
		        "recorded_datetime:[NOW-30DAYS TO NOW]",
		        "transaction_source:(ACRIS-DOC OR ACRIS)",
		        "sq_ft:[100 TO *]"
				],
			"sort": "sq_ft desc",
			"wt": "json",
			"rows": 999,
			
				
			}
		
	};
    const getTransactions = await _axiosCall(transCallData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getTransactions);
    }
    return getTransactions;
};

export const _getRefinaceClosedSales = async (query, type, obj) => {
	const fields = 'display_full_street_address,address_2_normalized,borough,borough_code,neighborhood,recorded_datetime,'
	        + 'close_date_formatted,contract_date_formatted,sales_document_ids,census_tract,price,financed_amt,'
	        + 'percent_financed,lender,ownership_type,owner,document_ids';
	
	let fQuery = 'status:(sold) AND source_namespace:WE3 AND transaction_source:(ACRIS-DOC OR ACRIS) AND -lender:mers*'
	        + ' AND -lender:mrs AND -lender:*electronic* AND -lender:*department* AND ownership_type:(condo* coop* *family*) AND census_tract:*'
	        + ' AND close_date_formatted:[NOW-15YEARS TO NOW-11YEARS] AND -owner:*llc* AND percent_financed:[10 TO 100]';
	
	if(['lmi', 'lmi-high'].indexOf(type) >= 0) {
		const lmiQuery = _getLMITract(type);
		fQuery  += ' AND ' + lmiQuery;
	}
	
	const transCallData = {
	    url: baseAPI + 'we3-transactions?cache=1440',
	    method: 'post',
	    query: {
	      fq: fQuery,
	      wt: 'json',
	      fl: fields,
	      rows: 20,
	      sort: 'percent_financed asc',
	      q: query,
	    }
	};
    const getTransactions = await _axiosCall(transCallData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getTransactions);
    }
    return getTransactions;
};

export const _getClosedSalesMap = async (query, obj) => {
	const fields = 'price,financed_amt,geocode';
	const transCallData = {
	    url: baseAPI + 'we3-transactions?cache=1440',
	    method: 'post',
	    query: {
	      fq:
	        'status:(sold) AND source_namespace:WE3 AND transaction_source:(ACRIS-DOC OR ACRIS) AND -lender:mers*'
	        + ' AND -lender:mrs AND ownership_type:(condo* coop* *family*) AND census_tract:* AND parcels_count:[* TO 2] AND close_date_formatted:[NOW-1YEAR TO NOW]',
	      wt: 'json',
	      fl: fields,
	      rows: 999,
	      sort: 'recorded_datetime desc',
	      q: query,
	    }
	};
    const getTransactions = await _axiosCall(transCallData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getTransactions);
    }
    return getTransactions;
};

export const _getFinancingTrend = async (query, lmi, obj) => {
	const fields = 'display_full_street_address,address_2_normalized,borough,borough_code,neighborhood,recorded_datetime,'
	        + 'close_date_formatted,contract_date_formatted,sales_document_ids,census_tract,price,financed_amt,'
	        + 'percent_financed,lender,ownership_type';
	let fQuery = 'status:(sold) AND source_namespace:WE3 AND transaction_source:(ACRIS-DOC OR ACRIS) AND -lender:mers*'
	        + ' AND -lender:mrs AND -lender:mortgage* AND ownership_type:(condo* coop* *family*) AND parcels_count:[* TO 2]';
	
	if(lmi) {
		const lmiQuery = _getLMITract();
		fQuery  += ' AND ' + lmiQuery;
	}
	const transCallData = {
	    url: baseAPI + 'we3-transactions?cache=1440',
	    method: 'post',
	    query: {
	      fq: fQuery,
	      wt: 'json',
	      fl: fields,
	      rows: 0,
	      cache: 3600,
	      sort: 'recorded_datetime desc',
	      q: query,
	      "json.facet": {
            loan_amount: {
              range: {
                field: "close_date_formatted",
                start: "NOW-1YEAR",
                end: "NOW",
                gap: "+1MONTH",
                facet: {
                  lenders: {
                    type: "terms",
                    field: "lender",
                    limit: 50,
                    facet: {
                      total: "sum(financed_amt)"
                    }
                  }
                }
              }   
		    },
		  }
	    }
	};
    const getTransactions = await _axiosCall(transCallData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getTransactions);
    }
    return getTransactions;
};

export const _getTopAgents = async (query, type, obj) => {
	const fields = 'display_name,display_full_street_address,address_2_normalized,borough,borough_code,neighborhood,recorded_datetime,'
	        + 'census_tract,price,ownership_type,main_photo,contacts_json,type,building,key,active_date_start';
	let fQuery = 'borough_code:(1 2 3 4 5) AND listing_type:sale AND type:(condo* coop* *family*)'
	        + ' AND active_date_start:[NOW-1YEAR TO NOW] AND deleted:false AND source_namespace:(REBNY-VOW) AND -census_tract:""';
	
	
	if(['lmi', 'lmi-high'].indexOf(type) >= 0) {
		const lmiQuery = _getLMITract(type);
		fQuery  += ' AND ' + lmiQuery;
	}
// console.log(type, fQuery);	
	const callData = {
	    url: baseAPI + 'search-listings?cache=15',
	    method: 'post',
	    query: {
	      fq: fQuery,
	      wt: 'json',
	      fl: fields,
	      rows: 0,
	      cache: 360,
	      sort: 'active_date_start desc',
	      q: query,
	      'json.facet': {
	          listings: {
                type: "terms",
                field: "contact_emails",
                limit: 50,
              },
              
   		  }
	    }
	};
	
	if(false) {
		callData.query['json.facet'] = {
			listings: {
	            type: "terms",
	            field: "contacts",
	            limit: 20,
	            sort: 'volume desc',
	            facet:{
	                volume: "sum(price)",
	            }
          	}
		};
	}

    const getAgents = await _axiosCall(callData)
    .then(res => {	    
	   return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    
    const topAgents = getAgents.facets.listings.buckets;
    const agentKeys = [];
    for (let i = 0; i < topAgents.length; i++) {
		const agent = topAgents[i];
		agentKeys.push(agent.val);
	}
	const agentQuery = 'email:(' + agentKeys.join(' OR ') + ')';
    const agentCallData = {
	    url: baseAPI + 'search-agents',
	    method: 'post',
	    query: {
		  fq: 'deleted:false AND -search_string:*office* AND -search_string:*center* AND -search_string:*street* AND -search_string:*gallery* AND source_namespace:(REBNY-VOW NESTIO-MP MARKETPROOF-TFCORNERSTONE MARKETPROOF-ONEKEY BKMLS) AND company_name:*',
	      wt: 'json',
	      rows: 50,
	      cache: 3600,
	      q: agentQuery, 
	    }
	};
	const agentList = await _axiosCall(agentCallData)
	.then(list => {
		return list;
	}) 
	.catch(error => {
      console.log('inventory transactions error: ', error);
    });   
    
    if (typeof obj.callback === 'function') {
	    const alist = agentList.docs.map(agent => {
		    agent.count = topAgents.filter(stat => stat.val === agent.email)[0].count;
		    agent.volume = topAgents.filter(stat => stat.val === agent.email)[0].volume;
		    return agent;
	    });
	    
	    alist.sort((a, b) => (a.count > b.count ? -1 : b.count > a.count ? 1 : 0));
        obj.callback(alist);
    }
    return agentList;
};

export const _getListings = async (query, type, obj) => {
	const fields = 'display_name,display_full_street_address,address_2_normalized,borough,borough_code,neighborhood,recorded_datetime,'
	        + 'census_tract,price,ownership_type,main_photo,contacts_json,type,building,key,active_date_start,broker_display_name';
	
	let fQuery = 'sale_status:(active) AND borough_code:(1 2 3 4 5) AND listing_type:sale AND ownership_type:(condo* coop* *family*)'
	        + ' AND source_namespace:(REBNY NESTIO-MP MARKETPROOF-TFCORNERSTONE MARKETPROOF-MLSLI BKMLS) AND active_date_start:[* TO NOW]';
	if(['lmi', 'lmi-high'].indexOf(type) >= 0) {
		const lmiQuery = _getLMITract(type);
		console.log(lmiQuery);
		fQuery  += ' AND ' + lmiQuery;
	}
	
	const transCallData = {
	    url: baseAPI + 'search-listings?cache=15',
	    method: 'post',
	    query: {
	      fq: fQuery,
	      wt: 'json',
	      fl: fields,
	      rows: 20,
	      sort: 'active_date_start desc',
	      q: query,
	    }
	};
    const getTransactions = await _axiosCall(transCallData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getTransactions);
    }
    return getTransactions;
};


export const _getBuyers = async (obj) => {
	
	const callData = {
	    url: baseAPI + 'typeform?form=VGYgFN',
	    method: 'get',
	};
    const getBuyers = await _axiosCall(callData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('_getBuyers transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getBuyers);
    }
    return getBuyers;
};

export const _getListingStats = async (query, obj) => {
	const fields = 'display_name,display_full_street_address,address_2_normalized,borough,borough_code,neighborhood,recorded_datetime,'
	        + 'census_tract,price,ownership_type,main_photo,contacts_json,type,building,key,active_date_start';
	
	const fQuery = 'borough_code:(1) AND borough:manhattan AND listing_type:sale'
	        + ' AND source_namespace:(REBNY NESTIO-MP MARKETPROOF-TFCORNERSTONE MARKETPROOF-MLSLI BKMLS) AND active_date_start:[* TO NOW]';
	
	const transCallData = {
	    url: baseAPI + 'search-listings',
	    method: 'post',
	    query: {
	      fq: fQuery,
	      wt: 'json',
	      fl: fields,
	      rows: 0,
	      sort: null,
	      q: query,
	      "json.facet": {
            listing_trend: {
              range: {
                field: "active_date_start",
                start: "2019-01-01T01:00:01Z",
                end: "2020-02-01T01:00:01Z",
                gap: "+1MONTH",
                facet: {
                  price: "sum(price)"
                 }
              }   
		    },
		  }
	    }
	};
    const getTransactions = await _axiosCall(transCallData)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('inventory transactions error: ', error);
    });
    if (typeof obj.callback === 'function') {
        obj.callback(getTransactions);
    }
    return getTransactions;
};


